import { render } from "./RalucaRomanPage.vue?vue&type=template&id=9f71ecd6"
import script from "./RalucaRomanPage.vue?vue&type=script&lang=js"
export * from "./RalucaRomanPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__